import type { UseMutationResult } from '@tanstack/react-query';
import { useBffPostMutation } from '../bff';
import { BffQueryKey } from '../model/BffQueryKey';
import type { ReviewTypes } from './model';

export const useUpvoteReview = (reviewId: number): UseMutationResult<ReviewTypes> =>
    useBffPostMutation(`/turn-to/reviews/${reviewId}/voteup`, [], [BffQueryKey.TURN_TO_DATA]);
